import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { getSalesRepLoading } from '../store/sales-rep-store';
import { salesRepActions } from '../store/salesrep';

/* eslint-disable @typescript-eslint/member-ordering */
@Injectable({ providedIn: 'root' })
export class SalesRepFacade {
  constructor(private store: Store) {}
  switchCustomer(customerID: string) {
    this.store.dispatch(salesRepActions.switchCustomer({ customerID }));
  }
  salesRepLoading$ = this.store.pipe(select(getSalesRepLoading));
}
